<template>
  <div class="child">
    <div class="child__wrapper">
      <div class="child__age">
        <c-input
          v-model="child.age"
          floating-label="Возраст, лет"
          :clearable="true"
          type="price-number"
          :max-length="2"
          :invalid="error && error.age"
          :error="error && error.age"
        />
      </div>
      <div class="child__gender">
        <div class="c-input-label">Пол</div>
        <c-switcher2
          v-model="child.gender"
          type="group"
          class="h-switcher"
          :items="[
            { icon: 'male', value: 'm', tooltip: 'Мужской' },
            { icon: 'female', value: 'f', tooltip: 'Женский' },
          ]"
        />
      </div>
      <div class="child__remove">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          size="iconic"
          icon="trash"
          @click="$emit('remove')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CSwitcher2 from "@/components/controls2/Switcher";
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";

export default {
  components: { CSwitcher2, CInput, CButton },
  props: ["child", "error"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.child {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
    margin-bottom: 25px;
  }
  &__age,
  &__gender,
  &__remove {
    padding-left: 8px;
    padding-right: 8px;
  }
  &__age {
    width: 50%;
  }
  &__gender {
    width: calc(100% / 3);
  }
  &__remove {
    padding-top: 17px;
  }

  @include bootstrapSm {
    &__gender {
      width: auto;
    }
  }

  @include bootstrapMd {
    &__wrapper {
      margin-left: -15px;
      margin-right: -15px;
    }
    &__age,
    &__gender,
    &__remove {
      padding-left: 15px;
      padding-right: 15px;
    }
    &__age {
      width: calc(100% / 10 * 2);
    }
  }

  @include bootstrapLg {
    &__age {
      width: calc(100% / 12 * 2);
    }
  }
}
</style>
